import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Select from '../../../../components/form/Select';
import { getCountriesWithNumbers } from './utils';

const propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['phone', 'country']),
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

const CountrySelectModule = ({ value = '', onChange = null, ...rest }) => {
  const countries = useMemo(
    () => getCountriesWithNumbers(),
    // return getCountriesPhones(value);
    [value]
  );

  return (
    <Select {...rest} options={countries} value={value} onSelect={onChange} />
  );
};

CountrySelectModule.propTypes = propTypes;

export default CountrySelectModule;
